import { render } from "./RegionalCoverageRadio.vue?vue&type=template&id=71cbccdc"
import script from "./RegionalCoverageRadio.vue?vue&type=script&lang=js"
export * from "./RegionalCoverageRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__